module.exports = __webpack_public_path__ + "static/media/citrus_color_red.db620a3a.svg";